<app-dashboard-layout>
  <router-outlet></router-outlet>
</app-dashboard-layout>
